// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");

function $$Notification(props) {
  var handleClose = props.handleClose;
  var __isError = props.isError;
  var isError = __isError !== undefined ? __isError : false;
  var backgroundColorCSS = isError ? "bg-red-400" : "bg-teal-400";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                      children: props.text,
                      className: "mr-20-px"
                    }),
                JsxRuntime.jsx("a", {
                      children: JsxRuntime.jsx("img", {
                            src: Image$ReactHooksTemplate.closeIcon
                          }),
                      className: "w-15-px h-15-px flex-grow-0 flex-shrink-0",
                      href: "#",
                      onClick: (function ($$event) {
                          $$event.preventDefault();
                          Curry._1(handleClose, undefined);
                        })
                    })
              ],
              className: backgroundColorCSS + " flex justify-between items-center w-1/3\n    top-0 left-1/3 px-20-px py-10-px mx-auto"
            });
}

var make = $$Notification;

exports.make = make;
/* react/jsx-runtime Not a pure module */
